import React from 'react';
import { CalendarDaysIcon, ClipboardListIcon, ShieldIcon, UsersIcon, CheckIcon } from 'lucide-react';
const stats = [[CalendarDaysIcon, '365', 'Days of curriculum'], [ClipboardListIcon, '6', 'Coaching modules'], [UsersIcon, 'All', 'Age groups'], [ShieldIcon, 'Full', 'Game coverage']];
const tags = ['Attack', 'Defense', 'Set Pieces', 'Scrum / Lineout', 'Tactical Kicking', 'Physical Preparation', 'Leadership', 'Match Day'];
export function SystemSection() {
  return <section className="border-y-4 border-[#d4af37] bg-[#16161F] px-5 py-20" data-id="element-225" data-mp="31mjz0kg3lsoa">
      <div className="mx-auto max-w-6xl text-center" data-id="element-226" data-mp="2wspgvlg55lrb">
        <p className="inline-block bg-[#d4af37] px-4 py-2 text-xs font-bold uppercase tracking-widest text-[#0A0A0A]" data-id="element-227" data-mp="2srm1f0209rqm">
          The complete system to stop improvising training
        </p>
        <h2 className="mt-7 font-display text-5xl font-bold uppercase leading-none text-white sm:text-7xl" data-id="element-228" data-mp="2iur3ojdk3vde">
          Rugby <span className="text-[#d4af37]" data-id="element-229" data-mp="2duv18okicbzy">Ready</span>
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-base font-medium leading-relaxed text-[#B0B0C0]" data-id="element-230" data-mp="13z7zvg3y2yt3">
          365 days of structured sessions. Attack, defense, set pieces, tactical
          kicking, physical preparation and team leadership.{' '}
          <strong className="text-white" data-id="element-231" data-mp="u2cz0qk78mbn">Everything ready.</strong>
        </p>
        <div className="mt-11 grid grid-cols-2 gap-3 lg:grid-cols-4" data-id="element-232" data-mp="yzbvvgv8z7dj">
          {stats.map(([Icon, value, label]) => <div key={label} className="border border-[#d4af37]/25 bg-[#0A0A0A] p-6" data-id="element-233" data-mp="1mqr23kq5a8u2">
              <Icon className="mx-auto h-7 w-7 text-[#d4af37]" data-id="element-234" data-mp="1rp29losyw794" />
              <p className="mt-4 font-display text-4xl font-bold text-white" data-id="element-235" data-mp="1rmg0hkqfhjos">
                {value}
              </p>
              <p className="text-xs font-bold uppercase tracking-widest text-[#B0B0C0]" data-id="element-236" data-mp="1hqcu22ojmyw1">
                {label}
              </p>
            </div>)}
        </div>
        <div className="mt-4 border border-[#d4af37]/25 bg-[#0A0A0A] p-7" data-id="element-237" data-mp="1eh7s1defmm9">
          <p className="text-xs font-bold uppercase tracking-[.2em] text-white" data-id="element-238" data-mp="6c918ztozgsk">
            Full coverage, every category
          </p>
          <div className="mt-5 flex flex-wrap justify-center gap-2" data-id="element-239" data-mp="28zxqp4elrmw6">
            {tags.map(tag => <span key={tag} className="flex items-center gap-1.5 border border-[#d4af37]/25 bg-[#16161F] px-3 py-2 text-xs font-bold text-white" data-id="element-240" data-mp="2414nc4t15c9q">
                <CheckIcon className="h-3.5 w-3.5 text-[#d4af37]" data-id="element-241" data-mp="1ua08r679ntff" />
                {tag}
              </span>)}
          </div>
        </div>
      </div>
    </section>;
}